import 'css-chunk:../../src/components/form/form-range/index.module.scss';export default {
  "range": "_range_1bkvk_1",
  "option": "_option_1bkvk_13",
  "output": "_output_1bkvk_19"
};